// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"33aa5bf3","25":"5021374a","324":"765fab71","364":"3a97ba25","408":"0ef15d53","614":"8676f2e9","638":"a9d85aec","639":"db0d7e78","881":"e0742ee2","939":"9db2beb0"}[chunkId] + ".chunk.js";
};